/**
 * CivixThread theme colors – emerald primary (matches mobile app).
 * Use for buttons, links, and accents across dashboard and app.
 */
export const theme = {
  primary: "#047857",
  primaryHover: "#065f46",
  accent: "#047857",
  /** CSS gradient for primary buttons (smooth, matches download button) */
  gradient: "linear-gradient(135deg, #047857 0%, #059669 100%)",
  gradientSimple: "linear-gradient(135deg, #047857 0%, #059669 100%)",

  // Core UI (aligned with mobile src/constants/colors.js)
  background: "#ffffff",
  surface: "#f8fafc",
  text: "#0f172a",
  textSecondary: "#64748b",
  textBody: "#334155",
  border: "#cbd5e1",
  disabled: "#94a3b8",
  
  // Alert/Warning Colors
  warningBadgeBg: "#fffbeb",
  warningBadgeText: "#b45309",
  warningBadgeBorder: "#fde68a",

  /** Founding cohort highlight badge (pricing page) */
  foundingBadgeBg: "#fffbeb",
  foundingBadgeText: "#78350f",
  foundingBadgeBorder: "#d4a017",

  /** Join page surfaces and elevation */
  joinSurfaceMuted: "#f7f7f7",
  joinSurfaceElevated: "#ffffff",
  joinBorderMuted: "#e4e4e4",
  joinDeviceShell: "#d1d5db",
  joinDeviceScreen: "#e5e7eb",
  joinShadowCard: "0 2px 8px rgba(15, 23, 42, 0.06)",
  joinShadowElevated: "0 8px 24px rgba(15, 23, 42, 0.08)",
  joinFocusRing: "0 0 0 3px rgba(4, 120, 87, 0.35)",
};

export default theme;
